// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AndroidOutlinedSvg from "@fishx/icons-svg/es/asn/AndroidOutlined";
import FishxIcon from '../components/FishxIcon';

var AndroidOutlined = function AndroidOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AndroidOutlinedSvg
  }));
};

AndroidOutlined.displayName = 'AndroidOutlined';
export default React.forwardRef(AndroidOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AndroidOutlined.js
// module id = 1990
// module chunks = 0